





















































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';

import bButton from 'bootstrap-vue/es/components/button/button';
import bButtonClose from 'bootstrap-vue/es/components/button/button-close';
import listenOnRootMixin from 'bootstrap-vue/es/mixins/listen-on-root';
import {
  addClass,
  removeClass,
} from 'bootstrap-vue/es/utils/dom';

const FullscreenModalProps = Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
});

@Component({
  components: {
    FontAwesomeIcon,

    bButton,
    bButtonClose,
  },
})
export default class FullscreenModal extends mixins(FullscreenModalProps, listenOnRootMixin) {
  public readonly faChevronDown = faChevronDown;
  public isVisible = false;
  public slotProps: any = null;

  public mounted() {
    (this as any).listenOnRoot('show::fullscreen::modal', this.showHandler);
    (this as any).listenOnRoot('hide::fullscreen::modal', this.hideHandler);
  }

  public onBeforeEnter() {
    addClass(document.body, 'modal-open');
  }

  public onAfterLeave() {
    removeClass(document.body, 'modal-open');
  }

  public show() {
    this.isVisible = true;
  }

  public hide() {
    this.isVisible = false;
  }

  private showHandler(id: string, slotProps?: any) {
    if (this.id === id) {
      this.slotProps = slotProps || null;
      this.show();
    }
  }

  private hideHandler(id: string) {
    if (this.id === id) {
      this.slotProps = null;
      this.hide();
    }
  }
}

